import { AiOutlineClose } from "react-icons/ai";
import Footer from "@components/common/Footer.component";
import { LOGOS } from "@constants/images";
import { useRef, useEffect } from "react";
import {
  gangstabet,
  gbet,
  upgradeNfts,
  changeName,
  creatingStories,
  emeraldCity,
  emeraldCityLands,
  landCertificate,
  crown,
  emeraldCityGamePlay,
  sapphireCity,
  GangstaBetNFTExpansion,
  earningCrown,
  bank,
  GangstaBetP_REP,
  gbetBnusd,
  crownBnUsd,
} from "@misc/Links";

import { useNavigate } from "react-router-dom";

const HeaderItem = ({ setShowMenu, showMenu }: any) => {
  const navigate = useNavigate();
  const menuRef = useRef<any>();

  useEffect(() => {
    const handler = (event: any) => {
      if (!menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <div className="main-menu-item-wraper ">
      <div
        className={`menuItems wow animate__animated ${
          showMenu ? "animate__fadeInRight" : "animate__backOutRight"
        }`}
        ref={menuRef}
      >
        <div className="menuItems-logo">
          <p className="logoText">
            <img
              onClick={() => {
                navigate("/");
              }}
              src={LOGOS.GANGSTAVERSE}
              alt="gangstaaverse-logo"
            />
          </p>
          <AiOutlineClose
            onClick={() => {
              setShowMenu(false);
            }}
            className="close"
            size={27}
          />
        </div>

        <div className="menuItems-allItems">
          <div className="allItems">
            <h5
              className="heading"
              onClick={() => window.open(gangstabet, "_blank")}
            >
              GangstaBet
            </h5>
            <div className="sub-heading">
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(gbet, "_blank")}
                >
                  $GBET
                </p>
                <p className="title-desc">
                  Earn $GBET utility token daily by simply holding GangstaBet
                  NFTS.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(changeName, "_blank")}
                >
                  Name Change
                </p>
                <p className="title-desc">
                  Give a unique Name to your GangstaBet across the collection by
                  burning GBET.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(upgradeNfts, "_blank")}
                >
                  Upgrade NFTs
                </p>
                <p className="title-desc">
                  Upgrade your character’s skills by burning $GBET and move up
                  the ranks within the world of gangsters and detectives
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(creatingStories, "_blank")}
                >
                  Creating Stories
                </p>
                <p className="title-desc">
                  Create unique text based stories by burning $GBET.
                </p>
              </div>
            </div>
          </div>

          <div className="allItems">
            <h5
              className="heading"
              onClick={() => window.open(emeraldCity, "_blank")}
            >
              Emerald City{" "}
            </h5>
            <div className="sub-heading">
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(emeraldCityLands, "_blank")}
                >
                  Emerald City Lands
                </p>
                <p className="title-desc">
                  11,111 city blocks in The Emerald City divided into several
                  regions like Commercial Area, Government Area, Vacation Town,
                  Airport, Residential Area, Park, Apartments and Suburbs
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(crown, "_blank")}
                >
                  $CROWN
                </p>
                <p className="title-desc">
                  Governance token for the Emerald City in GangstaVerse.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(landCertificate, "_blank")}
                >
                  Land Certificates
                </p>
                <p className="title-desc">
                  3,400 Certificates minted with CROWN used to claim lands in
                  the Emerald City.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(emeraldCityGamePlay, "_blank")}
                >
                  Emerald City Gameplay
                </p>
                <p className="title-desc">
                  There will be two forms of interactive platforms (or games) in
                  the Gangstaverse ecosystem — Idle for web3 natives and Active
                  for web2 users.
                </p>
              </div>
            </div>
          </div>

          <div className="allItems">
            <h5
              className="heading"
              onClick={() => window.open(sapphireCity, "_blank")}
            >
              Sapphire City
            </h5>
            <div className="sub-heading">
              <div className="sep-sub-heading">
                <p
                  className="sub-title unClickable"
                  // onClick={() => window.open(GangstaBetNFTExpansion, "_blank")}
                >
                  GangstaVerse expansion into Polygon{" "}
                </p>
                <p className="title-desc">
                  GangstaVerse ecosystem explansion into Polygon.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p className="sub-title unClickable">Polygon GangstaBet NFTs</p>
                <p className="title-desc">
                  Receive Polygon Gangstabet NFTs by locking their CROWN in
                  Forex.
                </p>
              </div>
              {/* <div className="sep-sub-heading">
                <p className="sub-title">Partnerships</p>
                <p className="title-desc">
                  Upgrade your character’s skills by burning $GBET and move up
                  the ranks within the world of gangsters and detectives
                </p>
              </div> */}
            </div>
          </div>

          <div className="allItems">
            <h5
              className="heading"
              onClick={() => window.open(earningCrown, "_blank")}
            >
              Earn $CROWN
            </h5>
            <div className="sub-heading">
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(bank, "_blank")}
                >
                  Bank
                </p>
                <p className="title-desc">
                  Deposit CROWN in bank to receive xCROWN
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(gbetBnusd, "_blank")}
                >
                  GBET/bnUSD Liquidity Pair
                </p>
                <p className="title-desc">
                  300,000 CROWN is distributed among those who supply liquidity
                  in the GBET/bnUSD pool.
                </p>
              </div>
              <div className="sep-sub-heading">
                <p className="sub-title">CROWN/bnUSD Liquidity Pair</p>
                <p className="title-desc">
                  500,000 CROWN is distributed among those who supply liquidity
                  in the GBET/bnUSD pool
                </p>
              </div>
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() => window.open(GangstaBetP_REP, "_blank")}
                >
                  Stake ICX to GangstaBet p-rep
                </p>
                <p className="title-desc">
                  600,000 CROWN tokens is distributed to thos who delegates ICX
                  votes to the GangstaBet P-Rep
                </p>
              </div>
            </div>
          </div>
          {/* === */}
          <div className="allItems">
            <h5
              className="heading"
              // onClick={() => window.open(earningCrown, "_blank")}
            >
              Tools
            </h5>
            <div className="sub-heading">
              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() =>
                    window.open("https://docs.gangstabet.io/", "_blank")
                  }
                >
                  GangstaBet Documentation
                </p>
                <p className="title-desc">
                  Official documentation of GangstaBet project.
                </p>
              </div>

              <div className="sep-sub-heading">
                <p
                  className="sub-title"
                  onClick={() =>
                    window.open(
                      "https://rarityhunter.network/collection/gangstabet",
                      "_blank"
                    )
                  }
                >
                  Rarity tool
                </p>
                <p className="title-desc">
                  Tool built by one of our community members for listing &
                  checking GangstaBet NFTs.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HeaderItem;
